import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ShippingPackagesIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ecommerce/shipping-packages'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'shipping_packages_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'shipping_packages_list',
          meta: {
            permissions: ['administrator'],
          },
          component: ShippingPackagesIndex,
        },
      ],
    },
  ],
};
